var styles = {"tend-ui-form-root":"tend-ui-form-root"};

export { styles as default };
